import React, { Component } from 'react'
import { connect } from 'react-redux'


class Signup extends Component {


	render() {
		return (
			<div>
				<p>Signup</p>
			</div>
		)
	}

}


const mapStateToProps = state => {
    return {}
}

export default connect(mapStateToProps, { })(Signup)


// WEBPACK FOOTER //
// ./src/containers/Signup/index.js